import { Component, forwardRef, input, model } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

import {
  FieldString,
  FormBuilderBase
} from '@shared/components/row-edition-form/form-builder/form-builder.model';

import { getAsNullIfEmpty, unwrapValue, wrapValue } from '../row-edition-form.utils';

@Component({
  selector: 'app-string',
  imports: [FormsModule],
  templateUrl: './string.component.html',
  styles: [
    `
      :host {
        display: flex;
        width: 100%;
      }
    `
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => StringComponent),
      multi: true
    }
  ]
})
export class StringComponent implements ControlValueAccessor {
  id = input<FormBuilderBase['id']>();
  value = model.required<string | null>();
  minLength = input<FieldString['minLength']>();
  maxLength = input<FieldString['maxLength']>();
  placeholder = input<string>();
  wrapperProperty = input<string | undefined>(undefined);

  onChange = (_: string | null): void => {};
  onTouched = () => {};

  onInput(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.onChange(getAsNullIfEmpty(value));
  }
  writeValue(value: string): void {
    this.value.set(unwrapValue(value, this.wrapperProperty()) as string);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  registerOnChange(fn: any): void {
    this.onChange = (value: string | null) => fn(wrapValue(value, this.wrapperProperty()));
  }
  registerOnTouched(fn: never): void {
    this.onTouched = fn;
  }
}
